import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getUserAccess } from "../../Services/ApiCalling/User";
import {
  getRaTendersBiddersList,
  getTenderList,
  getTendersBiddersList,
  getTenderSpeceficDetail,
} from "../../Services/ReverseAuction/GetApi";

export const auctionGet = createAsyncThunk(
  "auctionGet/get",
  async ({ section, tenderType }) => {
    try {
      let data = await getTenderList({ section, tenderType });
      return { user: data };
    } catch (err) {}
  }
);

export const tenderSpecefic = createAsyncThunk(
  "tenderSpecefic/get",
  async (id) => {
    try {
      let data = await getTenderSpeceficDetail(id);
      return { user: data };
    } catch (err) {}
  }
);

export const auctionBidders = createAsyncThunk(
  "auctionBidders/get",
  async ({ section, tenderType }) => {
    try {
      let data = await getTendersBiddersList({ section, tenderType });
      return { user: data };
    } catch (err) {}
  }
);

export const auctionBiddersRa = createAsyncThunk(
  "auctionBiddersRa/get",
  async () => {
    try {
      let data = await getRaTendersBiddersList();
      return { user: data };
    } catch (err) {}
  }
);

export const activeTenderId = createAsyncThunk(
  "activeTenderId/get",
  async (id) => {
    try {
      return { id };
    } catch (err) {}
  }
);

export const activeView = createAsyncThunk("activeView/get", async (id) => {
  try {
    return { id };
  } catch (err) {}
});

const auctionSlice = createSlice({
  name: "auction",
  initialState: {
    tenderSpecefic: null,
    auctionGet: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(auctionGet.pending, (state) => {})
      .addCase(auctionGet.fulfilled, (state, action) => {
        state.auctionGet = action.payload?.user?.data?.data?.page;
      })
      .addCase(auctionGet.rejected, (state, action) => {});
    builder
      .addCase(tenderSpecefic.pending, (state) => {})
      .addCase(tenderSpecefic.fulfilled, (state, action) => {
        state.tenderSpecefic = action.payload?.user?.data?.data;
      })
      .addCase(tenderSpecefic.rejected, (state, action) => {});
    builder
      .addCase(auctionBidders.pending, (state) => {})
      .addCase(auctionBidders.fulfilled, (state, action) => {
        state.auctionGet = action.payload?.user?.data?.data?.page;
      })
      .addCase(auctionBidders.rejected, (state, action) => {});
    builder
      .addCase(auctionBiddersRa.pending, (state) => {})
      .addCase(auctionBiddersRa.fulfilled, (state, action) => {
        state.auctionGet = action.payload?.user?.data?.data;
      })
      .addCase(auctionBiddersRa.rejected, (state, action) => {});
    builder
      .addCase(activeTenderId.pending, (state) => {})
      .addCase(activeTenderId.fulfilled, (state, action) => {
        state.activeTenderId = action.payload?.id;
      })
      .addCase(activeTenderId.rejected, (state, action) => {});
    builder
      .addCase(activeView.pending, (state) => {})
      .addCase(activeView.fulfilled, (state, action) => {
        state.activeView = action.payload?.id;
      })
      .addCase(activeView.rejected, (state, action) => {});
  },
});

export default auctionSlice.reducer;
